import { useGetHeaderOffset } from './useGetHeaderOffset'

export const useContentHeight = () => {
  const { headerOffset } = useGetHeaderOffset({ isSideMenu: true })
  const useCategoryNav = localStorage.getItem('useCategoryNav') === 'true'

  // Additional offset for horizontal tabs when not using category nav
  const tabsOffset = useCategoryNav === false ? 132 : 106

  const contentHeight = `calc(100vh - ${headerOffset + tabsOffset}px)`

  const dispatchActiveTicketsContentHeight = useCategoryNav ? `calc(100vh - 410px)` : `calc(100vh - 510px)`

  return { contentHeight, dispatchActiveTicketsContentHeight }
}
